const COMMON_CONSTANTS = {
  limit: 15,
  limitPagination: 100,
};

const EMAIL_PATTERN = /^[\w\-.]+(\+\w+)?@([\w-]+\.)+[\w-]{2,}$/;

const DEFAULT_HEADER_HEIGHT = 89;
const UPLOAD_FILE_SIZE_LIMIT_FOR_RENTER = 25;

const SUPPORTED_IMAGE_FORMATS = ['.png', '.jpg', '.jpeg', '.webp'];
const SUPPORTED_PDF_FORMAT = ['.pdf'];

const ALLOWED_FORMATS_TO_UPLOAD_FILE = {
  'image/png': SUPPORTED_IMAGE_FORMATS,
  'image/webp': SUPPORTED_IMAGE_FORMATS,
  'image/jpeg': SUPPORTED_IMAGE_FORMATS,
  'image/jpg': SUPPORTED_IMAGE_FORMATS,
  'image/pjpeg': SUPPORTED_IMAGE_FORMATS,
  'image/jpe': SUPPORTED_IMAGE_FORMATS,
  'application/pdf': SUPPORTED_PDF_FORMAT,
};

const ALLOWED_FORMATS_TO_UPLOAD_IMAGES = {
  'image/png': SUPPORTED_IMAGE_FORMATS,
  'image/webp': SUPPORTED_IMAGE_FORMATS,
  'image/jpeg': SUPPORTED_IMAGE_FORMATS,
  'image/jpg': SUPPORTED_IMAGE_FORMATS,
  'image/pjpeg': SUPPORTED_IMAGE_FORMATS,
  'image/jpe': SUPPORTED_IMAGE_FORMATS,
};

const SIGNATURE_TYPES = {
  keyboard: 'keyboard',
  mouse: 'mouse',
};

const CREDIT_CHECK_AMOUNT = 20;
const NAME_PATTERN = /^[a-zA-Z0-9\s-'’.,]+$/;
const TU_ADDRESS_PATTERN = /^[a-zA-Z0-9 #(),&\.\-\'`_+~/\*]*$/;
const TU_CITY_PATTERN = /^[A-Za-z .',-]+$/;
const TU_ZIP_PATTERN = /^\d{5}$/;
const TU_SSN_PATTERN = /^\d{3}-\d{2}-\d{4}$/;

const GOOGLE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.rentzeme.zeme&hl=en_US';
const APP_STORE_URL =
  'https://apps.apple.com/us/app/zeme-real-estate-rentals/id6450527319';
const TEXT_ZEME_URL = 'https://textzeme.com';

export {
  COMMON_CONSTANTS,
  ALLOWED_FORMATS_TO_UPLOAD_FILE,
  ALLOWED_FORMATS_TO_UPLOAD_IMAGES,
  SUPPORTED_IMAGE_FORMATS,
  SUPPORTED_PDF_FORMAT,
  SIGNATURE_TYPES,
  DEFAULT_HEADER_HEIGHT,
  EMAIL_PATTERN,
  CREDIT_CHECK_AMOUNT,
  NAME_PATTERN,
  TU_CITY_PATTERN,
  TU_ADDRESS_PATTERN,
  TU_ZIP_PATTERN,
  TU_SSN_PATTERN,
  UPLOAD_FILE_SIZE_LIMIT_FOR_RENTER,
  GOOGLE_PLAY_STORE_URL,
  APP_STORE_URL,
  TEXT_ZEME_URL,
};
